// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export const StyledDivV3 = styled.div`
  background-color: rgb(243 243 243) !important;
  margin-bottom: 20px;
  padding-bottom: 24px;
  .image-link > pre {
    background-color: #162f42;
    color: #ffffff;
    white-space: break-spaces;
    font-size: 13px !important;
    margin: 0 !important;
    font-weight: 700;
    padding: 8px 20px !important;
    height: 31px;
    justify-content: center;
    align-items: center;
    line-clamp: 2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: horizontal;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: normal;
    letter-spacing: normal;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    @media (max-width: 1199px) {
      font-size: 12px !important;
      padding: 5px 3.5px !important;
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    background-color: rgb(225 225 225) !important;
  }
  .container-carousel {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    -ms-overflow-style: none;
    display: flex;
  }
  .container-carousel::-webkit-scrollbar {
    display: none;
  }
  .carousel-inner-container {
    display: inline-block;
    width: 177px;
  }
  .slick-list {
    max-width: 100%;
    @media (min-width: 1200px) and (max-width: 1350px) {
      max-height: 250px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    .container-carousel-desktop {
      width: 100%;
    }
  }
  .heading {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    text-align: center;
  }
  .subheading {
    text-align: center;
    padding-left: 28px;
    padding-right: 28px;
    padding-top: 24px;
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1a1a1a;
    margin-bottom: 24px !important;
    text-transform: capitalize;
  }
  .slick-arrow {
    top: calc(50% - 20px);
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .heading {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
  }
  .tile-container {
    @media (min-width: 1351px) {
      width: 148px !important;
    }
    @media (min-width: 1200px) and (max-width: 1350px) {
      width: 136px !important;
    }
    border: 2px solid #dad8d8 !important;
    border-radius: 8px;
    @media (max-width: 1199px) {
      left: 0px;
      top: 0px;
      border: 1px solid #dad8d8;
      border-radius: 8px;
      margin-right: 5px !important;
      width: 100%;
    }
  }
  .carousel-image {
    @media (max-width: 1200px) {
      margin: 0 auto -6px;
    }
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .container-carousel .tile-container {
    @media (max-width: 1200px) {
      margin: 0 0 0 5px !important;
    }
  }

  @media (max-width: 1200px) {
    margin-bottom: 14px;
    padding-bottom: 15px;
    .subheading + div::before {
      display: none !important;
    }
    .container-carousel {
      padding-left: 0 !important;
      border: none !important;
    }
    .subheading + div {
      margin-left: 0 !important;
    }
    .subheading {
      padding-top: 15px;
      margin-bottom: 15px !important;
    }
  }
  @media (min-width: 1200px) {
    .slick-slider {
      margin-left: 1% !important;
    }
  }
  .slick-next {
    top: -31px;
    width: 18px;
    height: 21px;
    right: 14px;
    background: white url(${(props) => getIconPath('family-outfit-arrow', props)}) no-repeat center
      center;
    border-radius: 100%;
    padding: 19px;
    background-size: 6px;
  }

  .slick-prev {
    top: -31px;
    width: 18px;
    height: 21px;
    left: unset;
    right: 65px;
    background: url(${(props) => getIconPath('family-outfit-arrow', props)}) white no-repeat center
      center;
    border-radius: 100%;
    padding: 19px;
    background-size: 6px;
  }
  .slick-disabled {
    filter: opacity(50%);
  }
  .subheading + div {
    display: block !important;
  }
  .slick-slide div > div:nth-child(1):hover,
  .slick-slide div > div:nth-child(1):focus,
  .slick-slide div > div:nth-child(1):active,
  .slick-slide div > div:nth-child(1).clicked {
    border: 2px solid ${(props) => props.theme.colors.BRAND.PRIMARY} !important;
  }

  .aspect-ratio-box {
    height: 0;
    overflow: hidden;
    position: relative;
    padding-top: 124%;
    @media (max-width: 350px) {
      min-width: 120px;
    }
    @media (min-width: 351px) and (max-width: 409px) {
      min-width: 145px;
    }
    @media (min-width: 410px) and (max-width: 767px) {
      min-width: 165px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      min-width: 165px;
    }
  }
  .aspect-ratio-box-inside {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
export default StyledDivV3;
